export default __webpack_public_path__ + "static/media/email-icon-dark.39d00e49.svg";